import styled from 'styled-components';
import { FAMILY_FONT_CONTROL } from '../../const/text';
import { device } from '../../const/device';

export const H1 = styled.h1`
  font-size: 44px;
  line-height: 130%;
`;

export const H2 = styled.h2`
  font-size: 32px;
  line-height: 130%;
`;

export const P = styled.p<{ weight?: string}>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: ${props => props.weight};
  font-family: ${FAMILY_FONT_CONTROL};
  color: #000;
  margin: 20px 0px;

  @media (${device.mobileL}) {
    margin: 8px 0;
  }
`;

export const WarningContainer = styled.div<{isVisible}>`
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
`;

export const Warning = styled.p`
  font-size: 14px;
  font-weight: 500;
  font-family: ${FAMILY_FONT_CONTROL};
  color: red;
  margin: 0;
`;